export default __webpack_public_path__ + "static/media/2.9e96a5ba.jpg";